
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/context/auth-context";
import { Skeleton } from "@/components/ui/skeleton";

interface TechRouteGuardProps {
  children: React.ReactNode;
}

export const TechRouteGuard = ({ children }: TechRouteGuardProps) => {
  const { profile, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="container mx-auto pt-6 px-6 space-y-6">
        <Skeleton className="h-12 w-1/3" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  // Check if profile exists and has a valid tech role
  const hasTechAccess = profile?.role === 'tech' || profile?.role === 'superadmin';
  
  if (!hasTechAccess) {
    console.log('Access denied. Tech access required. Current profile:', profile);
    console.log('Current role:', profile?.role);
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
};
